import DocumentsTree from "./Tree";
import ShowDocs from "./Show";
import { useDocumentStore, useHeaderTextStore } from "../../Store";
import { useEffect, useState } from "react";

export default function Documents() {
  const { getDocuments } = useDocumentStore();
  const [selectedDoc, setSelectedDoc] = useState();
  const { setHeaderText } = useHeaderTextStore();

  useEffect(() => {
    setHeaderText("Dökümanlar");
    getDocuments();
  }, []);

  const handleSelectDoc = (e) => {
    setSelectedDoc(e);
  };

  return (
    <div className=" flex justify-center items-cente max-h-full">
      <div className=" w-1/3 shrink-0 border-r border-gray-200 py-1 px-3 max-h-full overflow-y-scroll">
        <DocumentsTree callback={handleSelectDoc} />
      </div>
      <div className=" w-2/3 shrink-0 border-l border-gray-200 py-1 px-3">
        {selectedDoc && <ShowDocs data={selectedDoc} />}
      </div>
    </div>
  );
}
